import { Component, OnInit } from '@angular/core';
//@ts-ignore
import * as cap_png from "../../../../assets/images/identy_logos_rgb_blue.png";

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.css']
})
export class SplashComponent implements OnInit {

  constructor() { }

  public readonly cap_image = cap_png['default'];
  ngOnInit() {}
}
